import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setParentPageOption: YJSChangeHandler<
  DatabaseChangeType.SET_PARENT_PAGE_OPTION
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.parentPageOption = change.parentPageOption;
  });
};
